import { shallowEqualArray } from '../util';
export function compareProps(a, b) {
    if (Object.is(a, b)) {
        return true;
    }
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) {
        return false;
    }
    for(let i = 0; i < aKeys.length; i++){
        const key = aKeys[i];
        if (!(key in b)) {
            return false;
        }
        const aValue = a[key];
        const bValue = b[key];
        switch(key){
            // TODO(koop): Our comparison heuristic can be improved:
            // - Handle `css` prop
            // - Handle `subviews` prop
            // - Handle instances of `toIntent` within `uses` prop
            case 'uses':
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (!shallowEqualArray(aValue, bValue)) {
                    return false;
                }
                break;
            default:
                if (!Object.is(aValue, bValue)) {
                    return false;
                }
        }
    }
    return true;
}

//# sourceMappingURL=compareProps.js.map